// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0ef15cb3","151":"8be21955","402":"5d636aac","442":"550505f2","653":"568b97c6","690":"7e01c4ba","754":"8b1ee567","921":"ab287f23"}[chunkId] + ".chunk.js";
};